import React from 'react'
const ArticleHeader = ({ category, title, author, publishedDate }) => {
  const formattedDate = new Date(publishedDate)?.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
  return (
    <div className="py-4">
      <p className="text-[16px] mt-0 font-[500] text-teal">
        {category && category.charAt(0).toUpperCase() + category.slice(1)}
      </p>
      <h2 className="mb-3 mt-6 tracking-[-.64px] md:tracking-[-1.68px] text-black">
        {title && title}
      </h2>
      {author || formattedDate ? (
        <p className="text-[16px] font-[500] mt-0 mb-3 text-black">
          {author && <span>By </span>}
          {author && <span>{author}</span>}
          {author && formattedDate && <span>{` | `}</span>}
          {formattedDate}
        </p>
      ) : null}
    </div>
  )
}
export default ArticleHeader
